__turbopack_context__.v({
  "ClearIcon": "DY44uq_ClearIcon",
  "ScrollShadow": "DY44uq_ScrollShadow",
  "SearchButton": "DY44uq_SearchButton",
  "SearchContainer": "DY44uq_SearchContainer",
  "SearchIcon": "DY44uq_SearchIcon",
  "SearchInput": "DY44uq_SearchInput",
  "bgBeige": "DY44uq_bgBeige",
  "fontGrilliBook": "DY44uq_fontGrilliBook",
  "leadingNone": "DY44uq_leadingNone",
  "textAltAlt": "DY44uq_textAltAlt",
  "textBlack": "DY44uq_textBlack",
  "textLg": "DY44uq_textLg",
  "textXl": "DY44uq_textXl",
});
